import {useEffect, useState} from "react";
import {useParams, useSearchParams, Link} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";

// Ф4 (23.08.2026) — С13: въведените БП и пътища по ползвател.
//
// Обхватът е землище ИЛИ община. От бутона в страницата на землището се влиза с
// землище; превключвателят отгоре позволява да се разшири до цялата община, без
// да се излиза от справката — това е и причината тя да е тук, а не в списъка на
// землището: числата за общината не се събират от един екран на землище.
export const ReportS13 = () => {
    const {year, settlement_ekatte} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const request = requester();

    // Обхватът се разпознава само от адреса. Името на общината НЕ се търси в
    // контекста — при директно отваряне или презареждане той е празен и
    // превключвателят изчезваше. Сървърът я извежда от землището.
    const обхват = searchParams.get('scope') === 'municipality'
        ? 'municipality' : 'settlement';

    const заявка = обхват === 'municipality'
        ? `municipality_of=${encodeURIComponent(settlement_ekatte)}`
        : `settlement=${encodeURIComponent(settlement_ekatte)}`;

    useEffect(() => {
        setLoading(true);
        setError(null);
        request.get(`${baseUrl()}/reports/s13/${year}?${заявка}`)
            .then(res => { setData(res); setLoading(false); })
            .catch(err => {
                setError((err && err.message) || 'Справката не се зареди.');
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, заявка]);

    const handlePdf = () => {
        const име = обхват === 'municipality'
            ? (data?.scope?.name || settlement_ekatte) : settlement_ekatte;
        downloadPdf(`/reports/s13/${year}?${заявка}&format=pdf`, `S13_${име}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (error) return <div className="mt-3 alert alert-warning">{error}</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const g = data.grand_totals;

    // При община показваме само землищата с ползватели; празните се изброяват
    // компактно накрая. При единично землище показваме и празното — иначе
    // екранът остава без никакво обяснение.
    const празни = data.settlements.filter(s => s.rows.length === 0);
    const сПоказване = data.scope.type === 'municipality'
        ? data.settlements.filter(s => s.rows.length > 0)
        : data.settlements;

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С13 — БП и пътища</h5>
                    <div>
                        {data.scope.type === 'settlement'
                            ? `Землище: ${data.scope.name} | ЕКАТТЕ: ${data.scope.ekatte}`
                            : `Община: ${data.scope.name}`}
                    </div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                    <div className="btn-group btn-group-sm">
                        <button
                            className={`btn ${обхват === 'settlement' ? 'btn-warning' : 'btn-outline-secondary'}`}
                            onClick={() => setSearchParams({})}>
                            Землището
                        </button>
                        <button
                            className={`btn ${обхват === 'municipality' ? 'btn-warning' : 'btn-outline-secondary'}`}
                            onClick={() => setSearchParams({scope: 'municipality'})}>
                            Цялата община
                        </button>
                    </div>
                    <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
                </div>
            </div>

            {сПоказване.map(s => (
                <div key={s.ekatte} className="mb-4">
                    {data.scope.type === 'municipality' && (
                        <h6 style={{color: "var(--app-gold)"}}>
                            {s.name} <span className="text-muted">({s.ekatte})</span>
                        </h6>
                    )}
                    {s.rows.length === 0 ? (
                        <div className="text-muted">Няма ползватели с данни.</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered">
                                <thead className="tableHead">
                                <tr>
                                    <th>Ползвател</th>
                                    <th>Булстат</th>
                                    <th className="text-end">БП</th>
                                    <th className="text-end">Пътища</th>
                                    <th className="text-end">Общо</th>
                                </tr>
                                </thead>
                                <tbody>
                                {s.rows.map(row => (
                                    <tr key={row.bullstat}>
                                        <td>
                                            <Link to={`/info/${year}/${s.ekatte}/${row.bullstat}`}
                                                  style={{textDecoration: "none", color: "var(--app-gold)"}}>
                                                {row.company_name}
                                            </Link>
                                        </td>
                                        <td>{row.bullstat}</td>
                                        <td className="text-end">{row.white_spots.toFixed(2)}</td>
                                        <td className="text-end">{row.roads.toFixed(2)}</td>
                                        <td className="text-end">{row.total.toFixed(2)}</td>
                                    </tr>
                                ))}
                                </tbody>
                                <tfoot>
                                <tr className="fw-bold">
                                    <td>Общо за землището</td>
                                    <td></td>
                                    <td className="text-end">{s.totals.white_spots.toFixed(2)}</td>
                                    <td className="text-end">{s.totals.roads.toFixed(2)}</td>
                                    <td className="text-end">{s.totals.total.toFixed(2)}</td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    )}
                </div>
            ))}

            {data.scope.type === 'municipality' && празни.length > 0 && (
                <div className="mb-3" style={{fontSize: "13px", color: "var(--app-muted)"}}>
                    <strong>Без ползватели за {data.year}</strong> ({празни.length}{' '}
                    {празни.length === 1 ? 'землище' : 'землища'}):{' '}
                    {празни.map(s => s.name).join(', ')}
                </div>
            )}

            {data.scope.type === 'municipality' && (
                <div className="alert alert-secondary">
                    <strong>ОБЩО за община {data.scope.name}:</strong>{" "}
                    БП {g.white_spots.toFixed(2)} · пътища {g.roads.toFixed(2)} ·
                    общо {g.total.toFixed(2)}
                </div>
            )}
        </div>
    );
};
